var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11432_4700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03398 0C7.76486 0 8.35285 0.587997 8.35285 1.31887V3.51699H16.2661V1.31887C16.2661 0.587997 16.8541 0 17.585 0C18.3158 0 18.9038 0.587997 18.9038 1.31887V3.51699H21.1019C23.0418 3.51699 24.6189 5.09414 24.6189 7.03398V7.91323V10.551V24.6189C24.6189 26.5588 23.0418 28.1359 21.1019 28.1359H3.51699C1.57715 28.1359 0 26.5588 0 24.6189V10.551V7.91323V7.03398C0 5.09414 1.57715 3.51699 3.51699 3.51699H5.71511V1.31887C5.71511 0.587997 6.30311 0 7.03398 0ZM21.9812 10.551H2.63774V24.6189C2.63774 25.1025 3.0334 25.4982 3.51699 25.4982H21.1019C21.5855 25.4982 21.9812 25.1025 21.9812 24.6189V10.551ZM18.0795 16.321L11.9248 22.4758C11.4082 22.9923 10.573 22.9923 10.0619 22.4758L6.5449 18.9588C6.02834 18.4422 6.02834 17.6069 6.5449 17.0959C7.06146 16.5848 7.89674 16.5793 8.40781 17.0959L10.9906 19.6787L16.2111 14.4581C16.7277 13.9416 17.563 13.9416 18.074 14.4581C18.5851 14.9747 18.5906 15.81 18.074 16.321H18.0795Z",
    fill: "#084172"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11432_4700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6189,
    height: 28.1359,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendarCheck.e5f13352cfd3e67bd0d7bdb2ac478531.svg";
export { ForwardRef as ReactComponent };